import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
    Button, Box, IconButton, OutlinedInput, FormControl
} from "@mui/material";
import {Brightness1 as CircleIcon, ArrowBackIosNewRounded as ArrowBackIosNewRoundedIcon} from "@mui/icons-material/";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../../utils/http-common";
import TemplateChart from "../../TemplateChart";
import { setTemplateForView } from "../../../Slices/templateslice";
import profilepic from "../../../assets/landing_page/new/pro.jpeg";
import Like from '../../../assets/planshare icons/like-red.png';
import Unlike from '../../../assets/planshare icons/like.png';
import Saved from '../../../assets/planshare icons/download.png';
import WhiteSaved from '../../../assets/planshare icons/download-white.png';
import MailIcon from '../../../assets/planshare icons/Mail.png';
import LinkedInIcon from '../../../assets/planshare icons/linkedin.png';
import TwitterIcon from '../../../assets/planshare icons/twitter.png';
import Favorite from '../../../assets/planshare icons/favorite.png';
//import Share from '../../../assets/planshare icons/share.png';
import Aerospace from '../../../assets/planshare icons/Aerospace.png';
import Agriculture from '../../../assets/planshare icons/Agriculture.png';
import Automobile from '../../../assets/planshare icons/Automobile.png';
import Chemical from '../../../assets/planshare icons/Chemical.png';
import Construction from '../../../assets/planshare icons/Construction.png';
import cardbackground from "../../../assets/landing_page/new/Frame 2095584531.svg";
import Finance from '../../../assets/planshare icons/Finance.png';
import Healthcare from '../../../assets/planshare icons/Healthcare.png';
import HeavyMachine from '../../../assets/planshare icons/Heavy Machine.png';
import Mining from '../../../assets/planshare icons/Mining.png';
import Nuclear from '../../../assets/planshare icons/Nuclear.png';
import Oil from '../../../assets/planshare icons/Oil & Gas.png';
import Pharmaceutical from '../../../assets/planshare icons/Pharmaceutical.png';
import Power from '../../../assets/planshare icons/Power & utility.png';
import Retail from '../../../assets/planshare icons/Retail Supply chain.png';
import Telecom from '../../../assets/planshare icons/Telecom.png';
import Ship from '../../../assets/planshare icons/Ship building.png';
import Software from '../../../assets/planshare icons/Software.png';
import Insurance from '../../../assets/planshare icons/insurance.png';
import favoriteIcon from '../../../assets/planshare icons/favourite-yellow.png';
import unfavoriteIcon from '../../../assets/planshare icons/favorite.png';
import Road from '../../../assets/planshare icons/Road.png';
import Electronics from '../../../assets/planshare icons/Electronics.png';
import { Back } from "../../../components/public/Button";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteIcon from '@mui/icons-material/Delete';

export const AdminViewTemplate = (props) => {
    const [viewType, setViewType] = useState("taskList");
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const urlid = searchParams.get("id");
    const [templateData, setTemplateData] = useState([]);
    const [jsonData, setJsonData] = useState([]);
    const [comment, setComment] = useState("");
    const { id, isEdit, isView, isDelete, table, isShare } = useSelector(
        (state) => state.templateslice
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const UserId = localStorage.getItem("user_id");
    const UserName = localStorage.getItem("user_name");
    const icon = {
        "Aerospace": <img src={Aerospace} alt="aero" height={20} width={20} />,
        "Construction": <img src={Construction} alt="constr" height={20} width={20} />,
        "Pharmaceutical": <img src={Pharmaceutical} alt="pharma" height={20} width={20} />,
        "Oil & Gas": <img src={Oil} alt="oil" height={20} width={20} />, // You can use a more specific icon if available
        "Automobile": <img src={Automobile} alt="auto" height={20} width={20} />,
        "Power & utility": <img src={Power} alt="power" height={20} width={20} />,
        "Healthcare": <img src={Healthcare} alt="health" height={20} width={20} />,
        "Telecom": <img src={Telecom} alt="tele" height={20} width={20} />, // If available, replace with more specific tools icon
        "Finance": <img src={Finance} alt="finance" height={20} width={20} />,
        "Insurance": <img src={Insurance} alt="insur" height={20} width={20} />,
        "Road": <img src={Road} alt="insur" height={20} width={20} />,
        "Retail Supply chain": <img src={Retail} alt="retail" height={20} width={20} />,
        "Software": <img src={Software} alt="software" height={20} width={20} />,
        "Heavy Machine": <img src={HeavyMachine} alt="heavy" height={20} width={20} />,
        "Chemical": <img src={Chemical} alt="chemical" height={20} width={20} />,
        "Nuclear": <img src={Nuclear} alt="nuclear" height={20} width={20} />,
        "Electronics": <img src={Electronics} alt="nuclear" height={20} width={20} />,
        "Ship building": <img src={Ship} alt="ship" height={20} width={20} />,
        "Mining": <img src={Mining} alt="mine" height={20} width={20} />,
        "Agriculture": <img src={Agriculture} alt="agri" height={20} width={20} />,

    };
    const [anchorEl, setAnchorEl] = useState(null);
    const [url, setUrl] = useState("https://example.com/template-url"); // Example URL
    const [copied, setCopied] = useState(false);
    const [open1, setOpen1] = useState(false);
    const handleShareClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen1(true);
    };
    const toggleView = () => {
        setViewType((prev) => (prev === "taskList" ? "ganttChart" : "taskList"));
    };
    const handleClose = () => {
        setOpen1(false);
        setAnchorEl(null);
    };

    const linkToCopy = `https://app.planshare.ai/home/share?id=${id}`;

    const handleCopy = () => {
        navigator.clipboard
            .writeText(linkToCopy)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 2000);
            })
            .catch((error) => {
                console.error("Failed to copy the link: ", error);
            });
    };

    const open = Boolean(anchorEl);
    const id1 = open ? "share-popper" : undefined;


    useEffect(() => {
        if (isView && id) {
            fetchPlanData();
        }
    }, [id, isView]);
    const [isVisible, setIsVisible] = useState(true);

    // Add these handler functions
    const handleVisibilityToggle = async (commentId) => {
        const currentComment = comments.find(cmt => cmt.id === commentId);
    const newHideStatus = currentComment?.hide === "true" ? "false" : "true";
          const payload = {
        id: [commentId],
        hide: newHideStatus
    };
        try {
            const response = await http.post('/master_service/update_delete/entity_data', payload);

            if (response.status === 200) {
                setComments(comments.map(cmt => 
                cmt.id === commentId 
                    ? {...cmt, hide: newHideStatus}
                    : cmt
            ));
            toast.success(newHideStatus === "true" ? 'Comment hidden successfully' : 'Comment visible now');
            fetchCommentsData(templateId);
            }
        } catch (error) {
            console.error('Error updating visibility:', error);
            toast.error('Failed to update visibility');
        }
    };

    const handleDelete = async (commentId) => {
        // Find the comment to be deleted
    const commentToDelete = comments.find(cmt => cmt.id === commentId);
    
    // Initialize array of IDs to delete
    let idsToDelete = [commentId];
    
    // If this is a parent comment (seq_no has no dots), find all child comments
    if (commentToDelete && !commentToDelete.seq_no.includes('.')) {
        const childComments = comments.filter(cmt => 
            cmt.seq_no.startsWith(commentToDelete.seq_no + '.'));
        idsToDelete = [...idsToDelete, ...childComments.map(cmt => cmt.id)];
    }
    
    const payload = {
        id: idsToDelete
    };
        try {
            const response = await http.post('/master_service/update_delete/entity_data', payload);
            if (response.status === 200) {
                toast.success('Comment deleted successfully');
                // Refresh comments after deletion
                fetchCommentsData(templateId);
            }
        } catch (error) {
            console.error('Error deleting comment:', error);
            toast.error('Failed to delete comment');
        }
    };
    const [templateId, setTemplateId] = useState(() => localStorage.getItem("templateId") || null);
    const fetchPlanData = async () => {
        try {
            const response = await http.get(`/master_service/template/view/data/${templateId}`);
            if (response.status === 200) {
                const data = response.data;
                setTemplateData(data);
                await fetchCommentsData(templateId);
                const tagsArray = templateData.tags ? templateData.tags.split(",") : [];
                fetchJsonData(response.data.plan_id);
            }
        } catch (error) {
            console.error("Error fetching user data", error);
        }
    };

    const fetchJsonData = async (id) => {
        try {
            const response = await http.post(`/master_service/store-template-data`, {
                template_id: id,
            });
            if (response.status === 201) {
                setJsonData(response.data.data.data.tasks);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };

    const fetchCommentsData = async (id) => {

        const payload = {
            template_id: id
        }
        try {
            const response = await http.post(`/master_service/entity/list/details`, payload);
            if (response.status === 200) {
                // Extract and filter the nested data
                const filteredData = response.data.comments;
                sortCommentsBySeqNo(filteredData);
                setComments(filteredData);

            }
        } catch (error) {
            sortCommentsBySeqNo([]);
            setComments([]);
        }
    };

    const formatRelativeTime = (date) => {
        const now = new Date();
        const diff = now - date; // Difference in milliseconds
        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 12);

        if (seconds < 60) return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
        if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
        if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
        if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;
        if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
        return `${years} year${years > 1 ? "s" : ""} ago`;
    };

    const handleCopyAsPlan = async (user_id, id) => {
        const payload = {
            user_id: localStorage.getItem("user_id"),
            plan_name: templateData.plan_name,
            customer_name: templateData.customer_name,
            plan_description: templateData.plan_description,
            //access_details: "Read-only access",
            unload_file_Path: templateData.unload_file_Path
        };
        try {
            const Response = await http.post("/master_service/template/copy/as/plan", payload);
            const responseData = Response.data;
            toast.success("Template saved as plan!");
        } catch (error) {
            console.error("Error while processing file:", error);
            toast.error("Failed to save as plan, please retry.");
        }
    };

const sortComments = (comments) => {
  return comments.sort((a, b) => {
    const aSeqParts = a.seq_no.split('.');
    const bSeqParts = b.seq_no.split('.');
    
    // If both are parent comments (no dots), sort in descending order
    if (!a.seq_no.includes('.') && !b.seq_no.includes('.')) {
      return parseInt(b.seq_no) - parseInt(a.seq_no);
    }
    
    // Get parent numbers
    const aParent = parseInt(aSeqParts[0]);
    const bParent = parseInt(bSeqParts[0]);
    
    // If parents are different, sort by parent in descending order
    if (aParent !== bParent) {
      return bParent - aParent;
    }
    
    // For same parent, compare remaining parts in ascending order
    for (let i = 1; i < Math.min(aSeqParts.length, bSeqParts.length); i++) {
      const diff = parseInt(aSeqParts[i]) - parseInt(bSeqParts[i]);
      if (diff !== 0) return diff;
    }
    
    // If one is a child of the other, shorter one comes first
    return aSeqParts.length - bSeqParts.length;
  });
};

    const handleFavorite = async (user_id, id, user_favorite) => {
        if (templateData.user_favorite === "yes") {
            const payload = {
                user_id: localStorage.getItem("user_id"),
                template_id: templateData.id,
                favorite_template: "no",
                top_pick: "no",
            };

            try {
                const response = await http.post(
                    "/master_service/favt/top-pick/entry",
                    payload
                );
                const responseData = response.data.record;
                //toast.success("Template removed from favourites!");
                setTemplateData((prevData) => ({
                    ...prevData,
                    feature_template_details: {
                        ...prevData.feature_template_details,
                        dataValues: {
                            ...prevData.feature_template_details.dataValues,
                            favorite_template: "no",
                        },
                    },
                }));
                fetchPlanData();
            } catch (e) {
                console.error("Error updating unfavorite status:", e);
            }
        }
        else {
            const payload = {
                user_id: localStorage.getItem("user_id"),
                template_id: templateData.id,
                favorite_template: "yes",
                top_pick: "no",
            };

            try {
                const response = await http.post(
                    "/master_service/favt/top-pick/entry",
                    payload
                );
                const responseData = response.data.record;
                //toast.success("Template added to favourites!");
                setTemplateData((prevData) => ({
                    ...prevData,
                    feature_template_details: {
                        ...prevData.feature_template_details,
                        dataValues: {
                            ...prevData.feature_template_details.dataValues,
                            favorite_template: "yes",
                        },
                    },
                }));
                fetchPlanData();
            } catch (e) {
                console.error("Error updating favorite status:", e);
            }
        }

    };

    const handleLike = async () => {
        if (templateData.likes_value === "yes") {
            const payload = {
                user_id: templateData.user_id,
                template_id: templateData.id,
                likes: "no"
            }
            try {
                const response = await http.post(`/master_service/template/like/click`, payload);
                if (response.status === 200) {
                    //toast.success("Template unliked successfully!");
                    setTemplateData((prevData) => ({
                        ...prevData,
                        likes_value: "no",
                    }));
                    fetchPlanData();
                }
            } catch (error) {
                console.error("Error fetching data");
            }
        } else {
            const payload = {
                user_id: templateData.user_id,
                template_id: templateData.id,
                likes: "yes"
            }
            try {
                const response = await http.post(`/master_service/template/like/click`, payload);
                if (response.status === 200) {
                    //toast.success("Template liked successfully!");
                    setTemplateData((prevData) => ({
                        ...prevData,
                        likes_value: "yes",
                    }));
                    fetchPlanData();
                }
            } catch (error) {
                console.error("Error fetching data");
            }
        }
    };

    const handleDownload = async () => {
        const link = document.createElement("a");
        link.href = templateData.unload_file_Path;
        link.download = templateData.unload_file_Path.split("/").pop(); // Extract the file name
        //link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        const payload = {
            user_id: templateData.user_id,
            template_id: templateData.id,
            top_pick: "yes"
        };
        try {
            const response = await http.post(
                "/master_service/template/toppick/entry/data",
                payload
            );
            toast.success("Template downloaded successfully!");
            fetchPlanData();
        } catch (e) {
            console.error("error", e);
        }
    };


    const handleReplyInputChange = (id, value) => {
        setReplies((prevReplies) => ({
            ...prevReplies,
            [id]: value, // Update the reply for the specific comment ID
        }));
    };

    const sortCommentsBySeqNo = (comments) => {
        return comments.sort((a, b) => {
            const seqA = a.seq_no.split(".").map(Number);
            const seqB = b.seq_no.split(".").map(Number);

            for (let i = 0; i < Math.max(seqA.length, seqB.length); i++) {
                const partA = seqA[i] || 0; // Default to 0 if part is missing
                const partB = seqB[i] || 0; // Default to 0 if part is missing

                if (partA !== partB) {
                    return partA - partB; // Sort based on difference
                }
            }

            return 0; // Equal seq_no
        });
    };

    const [reply, setReply] = useState({});
    const [comments, setComments] = useState([]);
    const handlePostComment = async (id, seq_no) => {
        const lastSingleDigitResponse = comments
            .filter(cmt => !cmt.seq_no.includes(".")) // Filter out those with sub-sequence numbers
            .reduce((last, cmt) => {
                if (!last || parseInt(cmt.seq_no) > parseInt(last.seq_no)) {
                    return cmt;
                }
                return last;
            }, null);
        const reply_comment = Object.values(replies);
        const payload = {
            entity: "Template",
            entity_id: templateData.id,
            user_id: localStorage.getItem("user_id"),
            routeSeqNo: seq_no || "",
            comments: comment.trim() || reply_comment[0]
        }
        try {
            const response = await http.post(
                "/master_service/entity/comments/creation",
                payload
            );
            toast.success("Comment posted successfully!");
            setComment("");
            setReplies({});
            //window.location.reload();
            await fetchCommentsData(response.data.newEntry.entity_id);
            //setComments([...comments, response.data.seq_no1]);
            sortCommentsBySeqNo([...comments, response.data.comments]);
            setComments(sortCommentsBySeqNo);
        } catch (e) {
            console.error("error", e);
        }
    };
    const [replyFields, setReplyFields] = useState({});
    const [replies, setReplies] = useState({});

    const handleReplyToggle = (commentId) => {
        setReplyFields((prev) => {
            // Create a new object where all fields are set to false
            const newReplyFields = Object.keys(prev).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});

            // Toggle the clicked comment's field
            return {
                ...newReplyFields,
                [commentId]: !prev[commentId],
            };
        });
    };

    const filteredComments = comments?.data
        ? Object.entries(comments.data).reduce((acc, [seqNo, commentList]) => {
            const matchedComments = commentList.filter(
                (comment) => comment.entity_id === templateData.id
            );

            if (matchedComments.length > 0) {
                acc[seqNo] = matchedComments;
            }

            return acc;
        }, {})
        : {};

    const handleNavigate = (path) => () => {
        navigate(path);
        dispatch(setTemplateForView({ id: null, isView: false }));
    };

    return (
        <div style={{ height: '100vh', overflowY: 'auto' }}>
            <div
                style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "14.52px",
                    textAlign: "left"
                }}>
                <span
                    style={{ cursor: "pointer" }}
                    onClick={handleNavigate(-1)}
                >
                    Manage Template
                </span> &gt; {templateData?.plan_name}
            </div>
            <Back prop={{ txt: templateData?.plan_name }} />
            <div style={{ display: "flex", gap: "20px", fontFamily: "Inter, sans-serif" }}>

                {/* Left Side Content */}
                <div style={{ width: "50%", height: "100%", marginLeft: "28px" }}>
                    <p style={{ fontFamily: "Inter, sans-serif", color: "gray", fontSize: "16px" }}>By {templateData.created_by} <CircleIcon style={{ height: "8px", width: "8px", color: "gray" }} /> {templateData?.feature_template_details?.dataValues?.likes ?? 0} <img src={Unlike} height="15px" width="15px" alt="like" /> <CircleIcon style={{ height: "8px", width: "8px", color: "gray" }} /> {templateData.top_pick_count ?? 0} <img src={Saved} height="15px" width="15px" alt="saved" /></p>
                    <p style={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "16px",
                        fontWeight: 600,
                        lineHeight: "21px",
                        marginLeft: "8px",

                    }}>{templateData.cost === "free" || "null" ? "" : templateData.cost}</p>
                    <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                        <button style={{ color: "white", backgroundColor: "#FF2800", padding: "6px", border: "none", borderRadius: "4px", fontSize: "12px", cursor: "pointer" }} onClick={() => handleDownload()}><img src={WhiteSaved} height="14px" width="15px" alt="saved" /> Download</button>
                        <button variant="outlined" onClick={() => handleCopyAsPlan()} style={{
                            backgroundColor: "white",
                            borderColor: "#D3D3D3", // Light gray border color
                            borderRadius: "4px",
                            borderWidth: "1px", // Ensure the border is visible
                            color: "black",
                            cursor: "pointer"
                        }}>Copy as plan</button>
                        <button variant="outlined" onClick={() => handleFavorite()} style={{
                            backgroundColor: "white",
                            borderColor: "#D3D3D3", // Light gray border color
                            borderRadius: "4px",
                            borderWidth: "1px", // Ensure the border is visible
                            color: "black",
                            cursor: "pointer"
                        }}>
                            {templateData?.user_favorite === "yes" ? (
                                <img
                                    src={favoriteIcon}
                                    style={{ height: "20px", width: "20px" }}
                                    alt="favorite"
                                />
                            ) : (
                                <img
                                    src={unfavoriteIcon}
                                    style={{ height: "20px", width: "20px" }}
                                    alt="unfavorite"
                                />
                            )}
                        </button>

                        <button variant="outlined" onClick={() => handleLike()} style={{
                            backgroundColor: "white",
                            borderColor: "#D3D3D3", // Light gray border color
                            borderRadius: "4px",
                            borderWidth: "1px", // Ensure the border is visible
                            color: "black",
                            cursor: "pointer"
                        }}>
                            {templateData?.likes_value === "yes" ? (
                                <img
                                    src={Like}
                                    style={{ height: "20px", width: "20px" }}
                                    alt="like"
                                />
                            ) : (
                                <img
                                    src={Unlike}
                                    style={{ height: "20px", width: "20px" }}
                                    alt="unlike"
                                />
                            )}
                        </button>
                    </div>

                    <h5>Description</h5>
                    <p style={{ fontFamily: "Inter, sans-serif", color: "gray", fontSize: "16px" }}>{templateData.plan_description}</p>
                    <h5>Category</h5>
                    {templateData.category ? (<Button
                        key={templateData.category}
                        startIcon={icon[templateData.category]}
                        variant={"outlined"}
                        sx={{
                            flex: "0 0 auto",
                            textTransform: "none",
                            fontFamily: "Inter, sans-serif",
                            borderRadius: "20px",
                            fontSize: { xs: "12px", sm: "12px" },
                            color: "gray",
                            backgroundColor: "transparent",
                            borderColor: "#D3D3D3",
                            cursor: "default",
                            "&:hover": {
                                backgroundColor: "transparent", // Prevent background color change
                                borderColor: "#D3D3D3", // Prevent border color change
                                boxShadow: "none", // Prevent shadow effect
                            },

                        }}
                    >
                        {templateData.category}
                    </Button>) : []}

                    <h5>Tags</h5>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1, // Adds space between buttons (both horizontally and vertically)
                        }}
                    >
                        {templateData.tags ? templateData.tags.split(",").map((tag, index) => (
                            <Button
                                key={index}  // Use index as key if tag doesn't have a unique ID
                                variant="outlined"
                                sx={{
                                    textTransform: "none",
                                    fontFamily: "Inter, sans-serif",
                                    borderRadius: "20px",
                                    fontSize: { xs: "12px", sm: "12px" },
                                    color: "gray",
                                    gap: "10px",
                                    backgroundColor: "transparent",
                                    borderColor: "#D3D3D3",
                                    cursor: "default",
                                    "&:hover": {
                                        backgroundColor: "transparent", // Prevent background color change
                                        borderColor: "#D3D3D3", // Prevent border color change
                                        boxShadow: "none", // Prevent shadow effect
                                    },
                                }}
                            >
                                {tag.trim()}  {/* trim to remove any leading/trailing spaces */}
                            </Button>
                        )) : []}
                    </Box>
                </div>
                {/* Gantt Chart */}
                <div style={{ width: "50%", marginTop: "-25px" }}>
                    {/* <TaskList projectData={jsonData} /> */}
                    <TemplateChart projectData={jsonData} />
                </div>
            </div>
            <div style={{ width: "100%", marginTop: "-20px", marginLeft: "20px", fontFamily: "Inter, sans-serif" }}>
                <h5 style={{ marginLeft: "8px" }}>
                    Comments {comments.filter((cmt) => cmt?.seq_no?.length === 1).length > 0 &&
                        `(${comments.filter((cmt) => cmt?.seq_no?.length === 1).length})`}
                </h5>
                <div style={{ marginTop: "10px", marginRight: "20px" }}>
                    <FormControl sx={{ width: "100%" }}>
                        <OutlinedInput
                            placeholder='Add a comment...'
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            multiline
                            rows={3} // Specify the number of rows for multiline
                            sx={{ maxHeight: "150px" }} // Allow scrolling if content exceeds height
                        />
                        <button
                            onClick={handlePostComment}
                            style={{
                                position: "absolute",
                                right: "10px",
                                top: "15px",
                                padding: "4px 10px",
                                backgroundColor: "#FF2800",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "gray",
                                },

                            }}
                        >
                            Post
                        </button>
                    </FormControl>
                </div>
                {sortComments(comments)
                .filter(cmt => {
    // Check if it's a root level comment (single number)
    if (!cmt.seq_no.includes('.')) return true;
    
    // For nested comments, check if parent exists
    const parentSeqNo = cmt.seq_no.split('.').slice(0, -1).join('.');
    return comments.some(parentCmt => parentCmt.seq_no === parentSeqNo);
  })
                .map((cmt) => {
                    const isTopLevelComment = cmt?.seq_no.length === 1;
                    const isCreator = cmt.template_creater?.user_id === cmt.user_id;
                    return (
                        <div
                            key={cmt.id}
                            style={{
                                marginTop: 5, // Reduced marginTop for less vertical space
                                marginLeft: cmt?.seq_no?.includes(".") // Optional chaining here
                                    ? `${cmt?.seq_no.split(".").length * 18}px`
                                    : "3px", // Default marginLeft for non-nested seq_no
                                marginBottom: "1px", // Reduced marginBottom for less vertical space
                                padding: "5px", // Reduced padding for more compact comments
                                borderTop: isTopLevelComment ? "1px solid #ccc" : "none",
                                //borderBottom: "1px solid #ccc",
                            }}
                        >
                            {/* Display additional metadata (user and time) */}
                            <p style={{ margin: 0, display: "flex", alignItems: "center", fontSize: "12px", color: "black" }}>
                                {cmt.users?.uploaded_picture_path && cmt.users?.uploaded_picture_path !== "" ? (
                                    <img
                                        src={cmt.users?.uploaded_picture_path}
                                        alt="uploaded profile"
                                        style={{ borderRadius: "50%", marginRight: "5px" }}
                                        height={20}
                                        width={20}
                                    />
                                )
                                    : (
                                        <img
                                            src={profilepic}
                                            alt="default profile"
                                            style={{ borderRadius: "50%", marginLeft: "-5px" }}
                                            height={25}
                                            width={30}
                                        />
                                    )}
                                <span style={{ fontWeight: "bold" }}>{cmt.users.user_name || "Anonymous"}</span>{isCreator && (
                                    <span style={{ marginRight: "5px", fontSize: "12px", fontWeight: "bold", color: "black" }}>
                                        (Creator)
                                    </span>
                                )}
                                <CircleIcon style={{ height: "6px", width: "6px", color: "gray", margin: "0 5px", }} />{" "}
                                <span>{cmt.updatedAt ? formatRelativeTime(new Date(cmt.updatedAt)) : "Unknown"}</span>
                                <IconButton sx={{ color: 'none' }} onClick={() => handleVisibilityToggle(cmt.id)}>
                                    {cmt.hide === "true" ?
        <VisibilityOffIcon fontSize="small" sx={{ color: '#040815' }} />
        :
        <VisibilityIcon fontSize="small" sx={{ color: '#040815' }} />
    }
                                </IconButton>
                                <IconButton
                                    sx={{ color: 'none' }}
                                    onClick={() => handleDelete(cmt.id)}
                                >
                                    <DeleteIcon fontSize="small" sx={{ color: '#040815' }} />
                                </IconButton>
                            </p>
                            {/* Display comment sequence number and text */}
                            <p
                                onClick={() => handleReplyToggle(cmt.id)}
                                style={{
                                    cursor: "pointer",
                                    color: "gray",
                                    marginLeft: "25px",
                                    marginTop: 0, // Remove extra margin from the paragraph
                                    fontSize: "12px", // Adjust font size for a compact look
                                }}
                            >
                                {cmt.hide === "true" ? cmt.comments : cmt.comments || ""}<br /><span style={{
                                    cursor: "pointer", textDecoration: "underline", marginTop: "5px", // Add space between comment and "Reply?"
                                    display: "inline-block"
                                }}>Reply?</span>
                            </p>
                            {/* Reply field and post button */}
                            {replyFields[cmt.id] && (
                                <div style={{ marginTop: "3px", position: "relative", width: "450px" }}> {/* Adjust container width */}
                                    <textarea
                                        value={replies[cmt.id] || ""}
                                        onChange={(e) => handleReplyInputChange(cmt.id, e.target.value)}
                                        placeholder="Write your reply..."
                                        rows={3}
                                        style={{
                                            width: "100%", // Adjust based on container width
                                            padding: "5px 50px 5px 5px", // Add right padding for button space
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            boxSizing: "border-box", // Ensure padding doesn't overflow
                                        }}
                                    />
                                    <button
                                        onClick={() => handlePostComment(cmt.id, cmt.seq_no || "")}
                                        style={{
                                            position: "absolute",
                                            right: "10px", // Position inside the text area
                                            bottom: "10px", // Adjust to align with textarea content
                                            padding: "5px 10px",
                                            backgroundColor: "#FF2800",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                        }}
                                    >
                                        Reply
                                    </button>
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    );
}
